<template>
  <div class="has-text-centered">
    Loading your document
    <div style="margin-top: 15px;">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        loading: true
      }
    },
    methods: {
      async generateTemporaryFile() {
        return await this.$http.get(`/api/print/pdf/auth`);
      },
      async openViewerWithBlob(filename) {
        const pdfResponse = await this.$http.get(`/api/print/pdf?filename=${filename}`, {
          responseType: 'blob'
        });

        const blobUrl = URL.createObjectURL(pdfResponse.data);
        this.$router.push({ name: 'pdfViewer', query: { file: blobUrl } });
      }
    },
    async mounted() {
      if (!this.$store.getters.user.IsACID) {
        this.$router.push({ name: 'restricted' }); //TODO: Send the user to an upsell page.
      }
      else {
        try {
          const resp = await this.generateTemporaryFile();
          if (resp.data && resp.data.filename) {
            await this.openViewerWithBlob(resp.data.filename);
          } else {
            throw new Error('No filename returned for ACID PDF generation.');
          }
        } catch (error) {
          console.error('Failed to prepare ACID PDF:', error);
          const message = (error.response && error.response.data && (error.response.data.message || error.response.data.Message))
            || 'Failed to open the ACID PDF. Please try again.';
          this.$buefy && this.$buefy.toast && this.$buefy.toast.open({
            message,
            type: 'is-danger'
          });
          this.$router.push({ name: 'acidDocuments' });
        }
      }
    }
  }
</script>
